// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"386279d7","678":"73afa58c","888":"93a73f6a"}[chunkId] + ".chunk.css";
};